import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../environments/environments';

declare const bootstrap: any;

@Component({
  selector: 'app-header',
  imports: [RouterLink, MatButtonModule, CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  @ViewChild('navbar') navbar!: ElementRef;

  contactPath = environment.contactUs;

  constructor(public router: Router) {}

  navigateAndClose(route: string) {
    this.router.navigate([route]);
    this.closeMenu();
  }

  contactAndClose() {
    window.open(this.contactPath, '_blank');
    this.closeMenu();
  }

  closeMenu() {
    if (this.navbar) {
      const collapse = bootstrap.Collapse.getInstance(this.navbar.nativeElement)
        || new bootstrap.Collapse(this.navbar.nativeElement, { toggle: false });

      collapse.hide();
    }
  }
}
